import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { NgxActivityReportWrapperComponent } from '@go-modules/components/activity-report-wrapper/activity-report-wrapper.component';

export const ngxActivityReportWrapperModule = angular.module('ngxActivityReportWrapperModule', [])
	.directive('ngxActivityReportWrapper', downgradeComponent({ component: NgxActivityReportWrapperComponent }))
	.name;
